var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 44,
    viewBox: "0 0 45 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 22,
    r: 21,
    fill: "#0C1525",
    stroke: "url(#paint0_linear_9501_68775)",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9501_68775)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.6057 22.3333L16.5724 24.5L15.4457 27.9892C15.2637 28.5303 15.2614 29.1158 15.4392 29.6584C15.617 30.201 15.9654 30.6716 16.4324 31C16.8915 31.339 17.4477 31.5206 18.0184 31.5177C18.589 31.5149 19.1435 31.3277 19.5991 30.9842L22.4999 28.8492L25.4016 30.9817C25.8598 31.3187 26.4131 31.5018 26.9819 31.5046C27.5507 31.5073 28.1057 31.3297 28.5672 30.9971C29.0287 30.6645 29.3728 30.1942 29.5502 29.6537C29.7275 29.1133 29.7289 28.5305 29.5541 27.9892L28.4274 24.5L31.3941 22.3333C31.8517 21.9988 32.1919 21.5281 32.366 20.9887C32.5402 20.4492 32.5394 19.8685 32.3638 19.3295C32.1882 18.7905 31.8468 18.3208 31.3883 17.9874C30.9298 17.6541 30.3776 17.4741 29.8107 17.4733H26.1666L25.0607 14.0267C24.8868 13.4841 24.5451 13.0108 24.0849 12.6751C23.6246 12.3393 23.0696 12.1583 22.4999 12.1583C21.9302 12.1583 21.3752 12.3393 20.9149 12.6751C20.4547 13.0108 20.113 13.4841 19.9391 14.0267L18.8332 17.4733H15.1924C14.6255 17.4741 14.0734 17.6541 13.6149 17.9874C13.1564 18.3208 12.815 18.7905 12.6394 19.3295C12.4638 19.8685 12.463 20.4492 12.6371 20.9887C12.8113 21.5281 13.1515 21.9988 13.6091 22.3333H13.6057Z",
    fill: "#FAFAFA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9501_68775",
    x1: 2.5,
    y1: 64.5926,
    x2: 50.4216,
    y2: 59.8518,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.150307,
    stopColor: "#FF0E46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.336372,
    stopColor: "#E30036"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.548934,
    stopColor: "#FD264E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74141,
    stopColor: "#FF345D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.928887,
    stopColor: "#FD0A46"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9501_68775"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(12.5 12)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.afd67fda8853213b260266f985495f6d.svg";
export { ForwardRef as ReactComponent };